// extracted by mini-css-extract-plugin
export default {"vacancy":"vacancy_vacancy__Yvx6s"};